import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/web/app/layouts/default.vue").then(m => m.default || m)),
  error: defineAsyncComponent(() => import("/app/web/app/layouts/error.vue").then(m => m.default || m))
}